import invoke from 'lodash.invoke';
import {Button} from '@ultradent/components';
import {Navigate, useNavigate, useOutletContext, useLocation} from 'react-router-dom';

const NewExistingDecision = ( props ) => {
    const navigate = useNavigate();
    const context = useOutletContext();

    if ( !context.authorization(useLocation()).hasAccountDetails() ) {
        return <Navigate to="/"/>
    }

    return (
        <div>
        <h1 className="font-thin leading-tight text-center text-2xl md:text-4xl mainSubHeading mx-auto">Create a New
            Ultradent Account</h1>
        <div className="universalForm-container text-near-black my-4 md:my-12 mx-auto">
            <p className="leading-tight">Have you ordered from Ultradent before, either by phone, at a dental show, or
                through your sales rep?</p>
            <div className="button-bar flex-row mt-8">
                <Button tertiary onClick={() => {
                    invoke( context, 'setStep', 2 );
                    navigate( '/officeDetails' );
                }}>No</Button>
                <Button tertiary onClick={() => {
                    invoke( context, 'setStep', 2 );
                    navigate( '/verifyAccount', {state: {hasLicense: false}} );
                }}>Yes</Button>
            </div>
            <span onClick={() => navigate( -1 )} className="block text-center p-2 link-2 mt-8 mx-auto">Back</span>
        </div>
    </div>
    );
}

export default NewExistingDecision;
